import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useVersionStore } from '@/modules/docs/stores/version-store'
import { api } from '@/modules/shared/lib/axios'

import { useAuthStore } from '../stores/auth.store'
import { useToast } from './use-toast'
import { env } from '../infra/env'

export const useAuth = () => {
  const navigate = useNavigate()
  const { toast } = useToast()
  const {
    versionUrl,
    user,
    token,
    versionApp,
    actions: { clearAll },
  } = useAuthStore()

  const logout = () => {
    clearAll()
      window.location.reload()
  }

  const removeUserFromStorage = () => {
    clearAll()
  }

  const verifyToken = () => {
    if (!token) {
      toast.info({
        title: 'Sessão expirada',
        description: 'Por favor, faça login novamente.',
      })
      clearAll()
      setTimeout(() => {
        navigate('/login')
      }, 3000)
      return
    }

    api.defaults.headers.common.Authorization = `Bearer ${token}`

    if (env.VITE_API_URL_LOCKED) {
      api.defaults.baseURL = env.VITE_API_URL
      return
    }

    api.defaults.baseURL = versionUrl
  }

  useEffect(() => {
    verifyToken()
  }, [])

  return {
    removeUserFromStorage,
    verifyToken,
    logout,
    user,
    versionApp,
  }
}
